/* Custom Reaven — countdown per i drop (sections/countdown-banner.liquid).
   La deadline (data + ora) e' interpretata come ora italiana (Europe/Rome)
   per qualunque visitatore: la conversione wall-clock -> timestamp UTC usa
   Intl.DateTimeFormat, senza librerie esterne. */

if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      static TIME_ZONE = 'Europe/Rome';

      connectedCallback() {
        const date = (this.dataset.date || '').trim();
        const time = (this.dataset.time || '18:00').trim();
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^\d{1,2}:\d{2}$/.test(time)) {
          // Data non configurata o malformata: il timer resta su "--"
          return;
        }

        this.deadline = CountdownTimer.zonedTimeToUtc(date, time);
        this.timerEl = this.querySelector('[data-countdown-timer]');
        this.expiredEl = this.querySelector('[data-expired-message]');
        this.values = {
          days: this.querySelector('[data-days]'),
          hours: this.querySelector('[data-hours]'),
          minutes: this.querySelector('[data-minutes]'),
          seconds: this.querySelector('[data-seconds]'),
        };

        // Custom Reaven: sotto le 24 ore il blocco "giorni" sparisce invece di
        // mostrare 00; torna da solo se la scadenza viene spostata piu' avanti.
        this.unitaGiorni = this.values.days ? this.values.days.closest('.countdown-banner__unit') : null;

        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const remaining = this.deadline - Date.now();
        if (remaining <= 0) {
          this.expire();
          return;
        }
        const seconds = Math.floor(remaining / 1000);
        this.render({
          days: Math.floor(seconds / 86400),
          hours: Math.floor((seconds % 86400) / 3600),
          minutes: Math.floor((seconds % 3600) / 60),
          seconds: seconds % 60,
        });
      }

      render(parts) {
        Object.entries(parts).forEach(([unit, value]) => {
          if (this.values[unit]) this.values[unit].textContent = String(value).padStart(2, '0');
        });
        if (this.unitaGiorni) this.unitaGiorni.hidden = parts.days === 0;
      }

      expire() {
        clearInterval(this.interval);
        const behavior = this.dataset.expiryBehavior || 'hide';
        if (behavior === 'hide') {
          const section = this.closest('.shopify-section');
          (section || this).style.display = 'none';
        } else if (behavior === 'message') {
          this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          if (this.timerEl) this.timerEl.classList.add('hidden');
          if (this.expiredEl) this.expiredEl.classList.remove('hidden');
        } else {
          this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        }
      }

      /* Converte una data/ora "wall clock" nel fuso TIME_ZONE in un timestamp UTC.
         Metodo iterativo: parte da un guess UTC e corregge finche' il wall clock
         nel fuso target coincide (gestisce correttamente CET/CEST). */
      static zonedTimeToUtc(dateStr, timeStr) {
        const [year, month, day] = dateStr.split('-').map(Number);
        const [hour, minute] = timeStr.split(':').map(Number);
        const target = Date.UTC(year, month - 1, day, hour, minute, 0);
        const formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: CountdownTimer.TIME_ZONE,
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: false,
        });

        let timestamp = target;
        for (let i = 0; i < 3; i++) {
          const parts = {};
          formatter.formatToParts(new Date(timestamp)).forEach((part) => {
            parts[part.type] = part.value;
          });
          const wallClock = Date.UTC(
            Number(parts.year),
            Number(parts.month) - 1,
            Number(parts.day),
            Number(parts.hour) % 24,
            Number(parts.minute),
            Number(parts.second)
          );
          const diff = target - wallClock;
          if (diff === 0) break;
          timestamp += diff;
        }
        return timestamp;
      }
    }
  );
}
